import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from 'mobx';
//import ErrorBoundry from "../ErrorBoundry/ErrorBoundry";
//import getCropUrl from "../../utils/getCropUrl"
import getBoxPadUrl from "@utils/getBoxPadUrl"
import isRetina from "is-retina"
import {QuantityEdit} from "../Products/QuantityEdit";

@inject("store")
@observer

export default class BasketOrderList extends React.Component {
    @observable EditProduct = [];

    @observable currentOrder = null;

    constructor(props) {
        super(props);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.closeCart = this.closeCart.bind(this);
        this.toggleProductlineEdit = this.toggleProductLineEdit.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        //this.getProductProperty = this.getProductProperty.bind(this);
        this.getPrimaryImageUrl = this.getPrimaryImageUrl.bind(this);
        this.goToPage = this.goToPage.bind(this);

        this.updateQuantity = this.updateQuantity.bind(this);
        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);

        this.klarnaCheckoutDiv = React.createRef();

    }

    componentDidMount() {
        this.EditProduct = [];
    }


    openProductDialog(e, sku) {
        e.preventDefault();
        const navigationStore = this.props.store.navigation;
        navigationStore.openProductDialog(sku);
    }


    toggleProductLineEdit(e, sku) {
        e.preventDefault();
        e.stopPropagation();
        const index = this.EditProduct.indexOf(sku);
        if (index > -1) {
            this.EditProduct = [...this.EditProduct.slice(0, index), ...this.EditProduct.slice(index + 1)];
        } else {
            this.EditProduct.push(sku);
        }
    }

    removeProduct(e, sku, name) {
        e.stopPropagation();
        e.preventDefault();
        const order = this.props.order;

        if (!order) return;
        if (confirm("Are you sure that you want to remove:\n" + name + "\n" + sku)) {
            order.removeProduct(sku).then(res => {
                    //success
                },
                err => {
                    alert(err.message);
                });
        }
    }


    getPrimaryImageUrl(orderLine) {
        const retina = isRetina();
        const navigation = this.props.store.navigation;
        const imageWidth = 80 * (retina ? 2 : 1);
        const imageHeight = imageWidth;

        const url = orderLine.PrimaryImageUrl;
        return !url
            ? "/dist/img/no_image.jpg"
            : getBoxPadUrl(url, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url;
        //getCropUrl(url, "Default", imageWidth, navigation.ImageFormat, "f6f6f6").cropUrl;
    }

    goToPage(e, url) {
        //this.closeCart();
        e.preventDefault();
        const {navigation} = this.props.store;
        const newHistoryObject = navigation.mainRouter
            ? {
                pathname: url,
                search: navigation.mainRouter.location.search,
                hash: null,
                state: null,
            } : null;

        navigation.mainRouter.replace(newHistoryObject);
    }

    // goToPage(url) {
    //     this.closeCart();
    //     const { navigation } = this.props.store;
    //     navigation.mainRouter.push(url);
    // }


    closeCart() {
        const {navigation} = this.props.store;
        navigation.toolbarRouter.push("/");
    }

    updateQuantity(e, product) {
        const newQuantity = e.target.value;
        e.preventDefault();
        const changes = [
            {
                Sku: product.Sku,
                VariantSku: product.VariantSku,
                OriginalQuantity: newQuantity,
                ProductUrl: ""
            }
        ];
        const result = this.props.store.order.updateQuantities(changes);
    }

    increaseQuantity(e, product) {
        e.preventDefault();
        const changes = [
            {
                Sku: product.Sku,
                VariantSku: product.VariantSku,
                AddQuantity: 1,
                ProductUrl: ""
            }
        ];
        const result = this.props.store.order.increaseQuantities(changes);
    }

    decreaseQuantity(e, product) {
        e.preventDefault();
        const changes = [
            {
                Sku: product.Sku,
                VariantSku: product.VariantSku,
                AddQuantity: -1,
                ProductUrl: ""
            }
        ];
        const result = this.props.store.order.increaseQuantities(changes);
    }


    render() {
        const navigation = this.props.store.navigation;
        const order = this.props.order;
        const basketView = this.props.basketView ? true : false;

        let sortedVisualOrderLines = [];

        if (order && order.ProductList && order.ProductList.length > 0) {
            let visualOrderLines = [];
            order.ProductList.map(product => {

                product.OrderLines.map(orderLine => {

                    visualOrderLines.push(orderLine);
                });
            });

            sortedVisualOrderLines = visualOrderLines.slice().sort(function (a, b) {
                const sortValueA = a.IsGenerated ? 1 : 0;
                const sortValueB = b.IsGenerated ? 1 : 0;

                if (sortValueA < sortValueB) return -1;
                if (sortValueA > sortValueB) return 1;
                return 0;
            });
            
            
        }

        //let productNameArray = product.ProductName.split("|");
        //let productName = productNameArray[0];
        //let variantName = productNameArray[1];


        return (
            <div className="cart">

                <div className="cart-inner">
                    {/*<div className={"cart-header"}>*/}
                    {/*    <div className={"title"}>*/}
                    {/*        Varukorg*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="cart-content-header">
                        <div className="name">Produkt</div>
                        <div className="price hidden-md-down">À Pris</div>
                        <div className="sum">Summa</div>
                    </div>

                    <div className="cart-content scroll-content">
                        <div className="cart-scroll-inner">
                            <div className="cart-content-inner">
                                {sortedVisualOrderLines.length > 0 && sortedVisualOrderLines.map(orderLine => {
                                    const brand = orderLine.PropertyValueByKey("_brand");
                                    return (
                                        <div className="orderline" key={orderLine.Sku + "_" + orderLine.VariantSku}>
                                            <div className="orderline-image ">
                                                <a href={orderLine.ProductUrl}
                                                   onClick={(e) => {
                                                       e.preventDefault();
                                                       navigation.navigateToSiteUrl(null, orderLine.ProductUrl, null, null, navigation.getSearchParameters());
                                                   }}
                                                >
                                                    <img src={this.getPrimaryImageUrl(orderLine)} width={80} height={80} alt={orderLine.Name}/>
                                                </a></div>
                                            <div className="orderline-text">
                                                <a href={orderLine.ProductUrl}
                                                   onClick={(e) => {
                                                       e.preventDefault();
                                                       navigation.navigateToSiteUrl(null, orderLine.ProductUrl, null, null, navigation.getSearchParameters());
                                                   }}   
                                                >
                                                    <div className="brand"><strong>{brand}</strong></div>
                                                    {orderLine.ProductName}
                                                </a>
                                                <div className="quantity-and-price-container">
                                                    <div className="quantity-container basket">
                                                        <QuantityEdit
                                                            orderStore={this.props.store.order}
                                                            key={orderLine.Sku + "_" + orderLine.VariantSku}
                                                            sku={orderLine.Sku}
                                                            variantSku={orderLine.VariantSku}
                                                            quantity={orderLine.Quantity}
                                                            increments={1}
                                                        />
                                                    </div>

                                                    <div className="orderline-price hidden-md-down ">
                                                        {orderLine.DiscountFormatted.length > 0
                                                            ? <span className="listprice-value">{
                                                                orderLine.ListPriceFormatted} {order.Currency}</span>
                                                            : null}
                                                        <span className={orderLine.DiscountFormatted.length > 0 ? "discount-price" : ""}>
                                                        {orderLine.TotalFormatted === "N/A"
                                                            ? 0
                                                            : orderLine.PriceFormatted} {order.Currency}
                                                            </span>
                                                    </div>
                                                    
                                                    
                                                    <div className="orderline-price">
                                                        <span className={orderLine.DiscountFormatted.length > 0 ? "discount-price" : ""}>
                                                        {orderLine.TotalFormatted === "N/A"
                                                        ? 0
                                                        : orderLine.TotalFormatted} {order.Currency}
                                                            </span>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                        {sortedVisualOrderLines.length === 0 && <div className="cart-empty">{this.props.store.navigation.dictionary.YourBasketIsEmpty}</div>}
                    </div>
                    <div className={"cart-footer " + (basketView ? "basket" : "")}>
                        {order && order.ProductList && order.ProductList.length > 0 ?
                            <React.Fragment>

                                <dl className="cart-order-totals">
                                    <dt className="">{this.props.store.navigation.dictionary.SubTotalInclTax || "Subtotal"}</dt>
                                    <dd><strong>{order.SubTotalWithVATFormatted} {order.Currency}</strong></dd>
                                    <dt>
                                        {navigation.dictionary.Shipping}
                                    </dt>

                                    <dd>{order.ShippingTotalFormatted} {order.Currency}</dd>

                                    <dd className={"free-shipping-info"}>
                                        <span className={"free-shipping-info " + (parseFloat(order.FreeShippingInfo) > 0 ? "left" : "free")}>
                                            {parseFloat(order.FreeShippingInfo) > 0 && order.ShippingTotal !== 0
                                                ? this.props.store.navigation.dictionary.FreeShippingInfo.replace("{0}", order.FreeShippingInfo)
                                                : this.props.store.navigation.dictionary.FreeShipping}
                                        </span>
                                    </dd>

                                    <dt className="cart-sum-total">{this.props.store.navigation.dictionary.TotalInclTax}</dt>
                                    <dd className="cart-sum-total"><strong>{order.OrderTotalFormatted === "0.00" || order.OrderTotalFormatted === "0,00" ? 0 : order.OrderTotalFormatted} {order.Currency}</strong><br/><span
                                        className="vat-info">{this.props.store.navigation.dictionary.VatTotal} {order.TaxTotal > 0 ? order.TaxTotalFormatted : 0} {order.Currency}</span></dd>


                                </dl>

                                <div className="basket-cta-container mt-2">
                                    <button
                                        className="product-button-purchase"
                                        onClick={(e) => this.goToPage(e, this.props.store.navigation.mainTree.CheckoutUrl)}
                                    >
                                        {this.props.store.navigation.dictionary.GoToCheckout}
                                    </button>
                                </div>


                            </React.Fragment>
                            : null}
                    </div>

                </div>

            </div>
        );
    }
}